import { ArticleHeading4, ArticleParagraph1 } from '@cian/ui-kit';
import * as React from 'react';

import { Wrapper } from './components/Wrapper';
import * as styles from './styles.css';

interface IOfferValuationProps {
  title: string;
  description: string;
  pricesBlock: React.ReactElement;
  chartFilters?: React.ReactElement | null;
  chart?: React.ReactElement | null;
  button: React.ReactElement;
}

export const _OfferValuation: React.ForwardRefRenderFunction<HTMLDivElement, IOfferValuationProps> = (props, ref) => {
  const { title, description, pricesBlock, chart, chartFilters, button } = props;

  return (
    <Wrapper ref={ref}>
      <ArticleHeading4>{title}</ArticleHeading4>
      <div className={styles['description']}>
        <ArticleParagraph1>{description}</ArticleParagraph1>
      </div>
      <div className={styles['prices_block']}>{pricesBlock}</div>
      {chartFilters && <div className={styles['chart_filters']}>{chartFilters}</div>}
      {chart && <div className={styles['chart_wrapper']}>{chart}</div>}
      <div className={styles['link_btn']}>{button}</div>
    </Wrapper>
  );
};

_OfferValuation.displayName = 'OfferValuation';

export const OfferValuation = React.forwardRef(_OfferValuation);
